
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {IcraDairesiEntity} from "@/entity/IcraDairesiEntity";

@Component({
  components: {},
})
export default class IcraDairesiList extends Vue {
  items: IcraDairesiEntity[] = [];
  search: string = "";
  onFly = false;
  mahkeme:IcraDairesiEntity[] = [];

  headers = [
    {text: "İcra Dairesi", align: "start", value: "isim"},
    // Sutun yalniz kapatilmis daireleri isaretler; aktif olanlar bos kalir.
    // Liste zaten pasifleri gizledigi icin (bkz. gosterilecekler) isaretsiz her
    // satir aktiftir, ayrica cip basmaya gerek yok (kullanici karari 04.09.2026).
    {text: "Durum", value: "durum", sortable: false, width: 110},
    {text: "İl", value: "sehir.isim"},
    {text: "İlçe", value: "ilce.isim"}
  ];
  @Prop({})
  value!: IcraDairesiEntity;

  mounted() {
    this.load();
  }

  /** Telefon genisligi mi? (Vuetify xs = 600px alti) */
  get darEkran(): boolean {
    return this.$vuetify.breakpoint.xsOnly;
  }

  /**
   * Dar ekranda yalniz İcra Dairesi ve Durum sutunlari kalir; İl ve İlçe
   * ismin altinda kucuk yaziya iner. 375px'te dort sutun okunamiyor, mobil
   * kart dokumu ise kaydirmayi 3.5 ekrana cikariyordu.
   */
  get gosterilecekBasliklar(): any[] {
    if (!this.darEkran) {
      return this.headers;
    }
    return [
      { text: 'İcra Dairesi', align: 'start', value: 'isim', width: '55%' },
      { text: 'Durum', value: 'durum', sortable: false, align: 'center', width: '27%' },
    ];
  }

  /** "Denizli · Acıpayam" -- ilce yoksa yalniz il. */
  yerBilgisi(item: any): string {
    return [item.sehir && item.sehir.isim, item.ilce && item.ilce.isim]
        .filter((p: any) => !!p)
        .join(' · ');
  }

  /**
   * Satira tiklamak kaydi secer. Dar ekranda secim kutusu kucuk kaliyor ve
   * isabet ettirmek zor; tablo tek secimli oldugu icin satirin kendisi zaten
   * tek anlamli hedef.
   */
  satiraTiklandi(item: IcraDairesiEntity) {
    this.mahkeme = [item];
  }

  /**
   * TDT-3397: secici tekrar acildiginda o an secili olan daire TIKLI gelmeli.
   */
  @Watch("value", { immediate: true })
  onValueChange() {
    this.secimiEsitle();
  }

  @Watch("items")
  onItemsChange() {
    this.secimiEsitle();
  }

  /** Tablonun secimini disaridan gelen degere getirir. */
  private secimiEsitle() {
    const gelen: any = this.value;
    const id = gelen && gelen.id;
    if (!id) {
      this.mahkeme = [];
      return;
    }
    const kayit = (this.items as any[]).find((r: any) => r.id === id);
    this.mahkeme = [kayit || gelen];
  }

  /**
   * Turkce harf sirasiyla siralar; durum bilgisine BAKMAZ.
   */
  turkceSirala(items: any[], sortBy: string[], sortDesc: boolean[], locale: string): any[] {
    const kopya = items.slice();

    kopya.sort((a: any, b: any) => {
      for (let i = 0; i < sortBy.length; i++) {
        const alan = sortBy[i];
        const av = this.alanDegeri(a, alan);
        const bv = this.alanDegeri(b, alan);
        let fark = String(av).localeCompare(String(bv), locale || "tr", { numeric: true });
        if (sortDesc[i]) fark = -fark;
        if (fark !== 0) return fark;
      }

      // Sutun secilmemisse isme gore alfabetik.
      return String(a.isim || "").localeCompare(String(b.isim || ""), "tr", { numeric: true });
    });

    return kopya;
  }

  /** "sehir.isim" gibi noktali yollari cozer. */
  private alanDegeri(nesne: any, yol: string): any {
    return yol.split(".").reduce((o: any, k: string) => (o == null ? o : o[k]), nesne) ?? "";
  }

  /**
   * Pasif daireler GİZLENİR, kapatılmış olanlar GİZLENMEZ.
   *
   * Listede yalnız AKTİF ve KAPATILMIŞ daireler görünür; pasifler gizlenir.
   * Kapatılmışlar bilerek tutuluyor — kullanıcı eski bir daireyi seçmek
   * isteyebilir, turuncu çiple uyarılıyor (kullanıcı kararı).
   *
   * `aktif_mi` 2023'ten beri fiilen ölü bir alandı: kolon varsayılanı 0, toplu
   * aktifleştirme satırı 2023_11_01_102732 migration'ında yorumlanmış doğmuş
   * (f1b2a27ca) ve API'de hiçbir sorgu ona göre süzmüyordu; 1045 dairenin yalnız
   * 7'si aktifti. O yüzden bu süzme bir dönem "aktarım koşmadan çıkmasın" diye
   * işaretlenmişti.
   *
   * ⚠ O KISIT KALKTI: API tarafındaki migration artık mevcut bütün kayıtları
   * aktife çekiyor, yani süzme aktarım öncesinde de listeyi boşaltmıyor. Üç repo
   * aynı anda çıkabilir. Tek koşul migration'ın koşmuş olması -- bu bileşen zaten
   * kapatilan_mi alanını okuduğu için o koşul kendiliğinden zorunlu.
   *
   * Bayrakları anlamlı kılan şey aktarımın kendisi: UYAP listesinde yer alan her
   * daire aktife alınıyor, dosyada bulunmayan kapatılmış işaretleniyor. Uçtan uca
   * ölçüldü (81 il, 04.09.2026): migration sonrası 1045 kaydın 1045'i aktif ve
   * 58'i kapatılmış; aktarım sonrası 1149 kaydın 797'si UYAP kimlikli, tamamı
   * aktif, 351'i kapatılmış, seçicide pasif kalan 0.
   *
   * Sıralama DÜZ ALFABETİK -- durum sıraya karışmaz.
   *
   * ⚠ Bir önceki halinde kapatılmış daireler listenin sonuna itiliyordu.
   * KALDIRILDI (TDT-3397 geri dönüşü, kullanıcı kararı): daire alfabetik
   * sırada beklendiği yerde durmalı. Kapatılmış olduğunu isim yanındaki
   * turuncu çip söylüyor, listedeki konumu değil.
   */
  get gosterilecekler(): IcraDairesiEntity[] {
    return this.items
        .filter((r: any) => r.aktif_mi || r.kapatilan_mi)
        .slice()
        .sort((a: any, b: any) =>
            String(a.isim || "").localeCompare(String(b.isim || ""), "tr"));
  }

  load() {
    this.$helper.requestWithCache("/api/v1/icra-dairesi/").then((response) => (this.items = response.data));
  }

  /**
   * DEV-2770: burada eskiden secilen kaydin aktif_mi bayragi 1 yapilip
   * PUT /api/v1/icra-dairesi/{id} ile ortak icraproweb tablosuna yaziliyordu;
   * bir buronun secimi butun burolari etkiliyordu. Yazma ucu kaldirildi.
   *
   * Kullanici akisi degismedi: listeyi besleyen GET /api/v1/icra-dairesi
   * aktif_mi'ya bakmadan butun daireleri dondurdugu icin kayit zaten
   * secilebilir durumdaydi; bayrak hicbir okuma yolunu acmiyordu.
   */
  onItemActivated() {
    if (this.mahkeme.length > 0) {
      this.$emit("input", this.mahkeme[0]);
      this.$emit("close");
      // ⚠ Burada eskiden `this.mahkeme = []` vardi; secim kaydedildikten hemen
      // sonra tablo yine secimsiz kaliyordu. Secim artik korunuyor.
    }
  }

  close() {
    // Vazgecildi: tabloda tiklanan ama kaydedilmeyen satir birakilmaz, secim
    // disaridan gelen gercek degere dondurulur.
    this.secimiEsitle();
    this.$emit("cancel");
    this.$emit("close");
  }
}
